let dateServer = value => value.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
let FilterMobile = value => {
  if (value) {
    return value.replace(/(\d{3})\d*(\d{4})/, '$1****$2');
  } else {
    return '暂无手机号';
  }
}

export { FilterMobile }



// WEBPACK FOOTER //
// ./src/static/js/filters.js


// WEBPACK FOOTER //
// ./src/static/js/filters.js